<script lang="ts">
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	import { HeniExhibitionsLogo } from '$global/assets/logos/HeniExhibitionsLogo';
	import { IconLink } from '$global/components/IconLink';
	import { getNavBarContext } from '$global/features/navigation/utils/getNavBarContext/getNavBarContext';

	const { popover } = getNavBarContext();
</script>

<IconLink
	dataCy="header"
	href={GlobalRoutes.ExhibitionsHome}
	label="See HENI Exhibitions home page"
	class="outline-none"
	onclick={() => {
		popover?.states?.open?.set(false);
	}}
>
	<HeniExhibitionsLogo class="xs:scale-100 origin-left scale-75" />
</IconLink>
